import { useState } from "react"
import { createFileRoute, Link } from "@tanstack/react-router"
import { ArrowLeft } from "lucide-react"
import { AppShell } from "../components/layout/app-shell"
import { QueryState } from "../components/layout/query-state"
import { SearchRankingKeywordDetailView } from "../components/search-rankings/search-ranking-keyword-detail"
import { useSearchRankingKeyword } from "../services/use-search-rankings"

function SearchRankingKeywordPage() {
  const { marketplace, phrase } = Route.useParams()
  // Null follows the latest capture. Stepping to an older snapshot pins it here,
  // so the URL of record stays the keyword and a reload lands on today again.
  const [runId, setRunId] = useState<string | null>(null)
  const detail = useSearchRankingKeyword(marketplace, phrase, runId)
  return (
    <AppShell
      title={phrase}
      description={
        detail.data
          ? `${detail.data.category} · ${detail.data.marketplace.name} first-page ranking (${detail.data.marketplace.collectionProfile.tag.toUpperCase()} series)`
          : "Marketplace first-page ranking"
      }
      // The measured URL itself, not one rebuilt from the phrase — the page
      // behind a rank is one click from the rank.
      {...(detail.data ? { titleHref: detail.data.searchUrl } : {})}
      actions={
        <Link
          to="/keywords/$marketplace"
          params={{ marketplace }}
          className="inline-flex items-center gap-1.5 rounded-md border border-border bg-card px-3 py-1.5 text-xs font-medium text-muted-foreground transition-colors hover:text-foreground"
        >
          <ArrowLeft className="size-3.5" />
          All keywords
        </Link>
      }
    >
      <QueryState
        isLoading={detail.isLoading}
        error={detail.error}
        isEmpty={detail.data === undefined}
        emptyMessage="No measured capture for this keyword yet."
      >
        {detail.data ? (
          <SearchRankingKeywordDetailView
            detail={detail.data}
            onSelectRun={setRunId}
            isSwitchingCapture={detail.isFetching}
          />
        ) : null}
      </QueryState>
    </AppShell>
  )
}

export const Route = createFileRoute("/keywords/$marketplace/$phrase")({
  component: SearchRankingKeywordPage,
})
